// import React from 'react';
// import { Link } from 'react-router-dom';

// function NotFound() {
//   return (
//     <div style={{ textAlign: 'center', marginTop: '50px' }}>
//       <h1>404 - Page Not Found</h1>
//       <p>The page you are looking for does not exist.</p>
//       <Link to="/">Go back to Home</Link>
//     </div>
//   );
// }

// export default NotFound;

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to root
    navigate('/', { replace: true });
  }, [navigate]);

  // Return null or a loading message while redirecting
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <p>Redirecting to home...</p>
    </div>
  );
}

export default NotFound;